import { FC, SVGAttributes } from "react";

const BancontactIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Bancontact</title>
    <path
      d="M3.712 0.5H28.288C30.0493 0.5 31.5 1.95884 31.5 3.78681V20.2132C31.5 22.0411 30.0493 23.5 28.288 23.5H3.712C1.95064 23.5 0.5 22.0411 0.5 20.2132V3.78681C0.5 1.95884 1.95064 0.5 3.712 0.5Z"
      fill="white"
      stroke="#EEEEEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 13.1751C6 12.6522 6.41907 12.2283 6.93461 12.2283H9.78092L8.36308 13.6576H14.0345L16.8702 10.3226H23.0142L18.9156 14.8674C18.569 15.2518 17.8792 15.5633 17.3644 15.5633H6.9236C6.41351 15.5633 6 15.141 6 14.6166V13.1751Z"
      fill="#00549D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.7906 10.8693C25.7906 11.3896 25.3672 11.8114 24.8677 11.8114H21.5371L22.9549 10.3821H16.8109L14.4478 13.7171H8.30383L12.4314 8.72409C12.762 8.32419 13.4546 8.00001 13.9683 8.00001L24.8523 8.00001C25.3705 8.00001 25.7906 8.42246 25.7906 8.94216V10.8693Z"
      fill="#FFD800"
    />
  </svg>
);

export default BancontactIconBackground;
